import * as React from 'react';
import styled from 'styled-components';
import { Col, ColProps } from 'react-flexbox-grid';

const StyledCol = styled(Col)<ColProps>`
  padding-left: ${props => `${props.theme.gridGutter}px !important` || '8px'};
  padding-right: ${props => `${props.theme.gridGutter}px !important` || '8px'};
`;

export default (props: any) => <StyledCol {...props}>{props.children}</StyledCol>;



// WEBPACK FOOTER //
// ./src/components/primitives/Col.tsx